import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Facebook, Twitter, Instagram, Youtube, Linkedin, BookOpenText } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  
  const handleNavigation = (path: string) => {
    navigate(path);
  };
  
  return (
    <footer className="bg-gray-50/98 backdrop-blur supports-[backdrop-filter]:bg-gray-50/95 dark:bg-muted/20 py-8 md:py-12 border-t border-gray-100/50 dark:border-gray-800/20">
      <div className="container px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center sm:text-left">
            <h3 className="font-bold text-lg mb-4 text-gray-900">About Us</h3>
            <p className="text-gray-900 text-sm">
              PorteroYa connects amateur soccer teams with goalkeepers. Find or become a goalkeeper in Spain's leading football community.
            </p>
          </div>
          <div className="text-center sm:text-left">
            <h4 className="font-bold mb-4 text-gray-900">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Button 
                  variant="link" 
                  className="p-0 h-auto text-gray-900 hover:text-primary active:text-secondary transition-colors duration-200 no-underline hover:no-underline"
                  onClick={() => handleNavigation("/terms-privacy")}
                >
                  Terms & Privacy
                </Button>
              </li>
              <li>
                <Button 
                  variant="link" 
                  className="p-0 h-auto text-gray-900 hover:text-primary active:text-secondary transition-colors duration-200 no-underline hover:no-underline"
                  onClick={() => handleNavigation("/cookie-policy")}
                >
                  Cookie Policy
                </Button>
              </li>
              <li>
                <Button 
                  variant="link" 
                  className="p-0 h-auto text-gray-900 hover:text-primary active:text-secondary transition-colors duration-200 no-underline hover:no-underline"
                  onClick={() => handleNavigation("/blog")}
                >
                  Blog
                </Button>
              </li>
            </ul>
          </div>
          <div className="text-center sm:text-left">
            <h4 className="font-bold mb-4 text-gray-900">Support</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Button 
                  variant="link" 
                  className="p-0 h-auto text-gray-900 hover:text-primary active:text-secondary transition-colors duration-200 no-underline hover:no-underline"
                  onClick={() => handleNavigation("/help")}
                >
                  Help Center
                </Button>
              </li>
              <li>
                <Button 
                  variant="link" 
                  className="p-0 h-auto text-gray-900 hover:text-primary active:text-secondary transition-colors duration-200 no-underline hover:no-underline"
                  onClick={() => handleNavigation("/help#faq")}
                >
                  FAQ
                </Button>
              </li>
              <li>
                <Button 
                  variant="link" 
                  className="p-0 h-auto text-gray-900 hover:text-primary active:text-secondary transition-colors duration-200 no-underline hover:no-underline"
                  onClick={() => handleNavigation("/contact")}
                >
                  Contact Us
                </Button>
              </li>
            </ul>
          </div>
          <div className="text-center sm:text-left">
            <h4 className="font-bold mb-4 text-gray-900">Follow Us</h4>
            <div className="flex justify-center sm:justify-start flex-wrap gap-4">
              <Button 
                variant="ghost" 
                size="icon"
                className="h-8 w-8 hover:text-primary active:text-secondary transition-colors duration-200 text-gray-900"
                onClick={() => window.open('https://www.facebook.com/profile.php?id=61556743824804', '_blank')}
              >
                <Facebook className="h-4 w-4" />
              </Button>
              <Button 
                variant="ghost" 
                size="icon"
                className="h-8 w-8 hover:text-primary active:text-secondary transition-colors duration-200 text-gray-900"
                onClick={() => window.open('https://x.com/PorteroYa', '_blank')}
              >
                <Twitter className="h-4 w-4" />
              </Button>
              <Button 
                variant="ghost" 
                size="icon"
                className="h-8 w-8 hover:text-primary active:text-secondary transition-colors duration-200 text-gray-900"
                onClick={() => window.open('https://www.instagram.com/porteroyaoficial/', '_blank')}
              >
                <Instagram className="h-4 w-4" />
              </Button>
              <Button 
                variant="ghost" 
                size="icon"
                className="h-8 w-8 hover:text-primary active:text-secondary transition-colors duration-200 text-gray-900"
                onClick={() => window.open('https://www.linkedin.com/company/porteroya', '_blank')}
              >
                <Linkedin className="h-4 w-4" />
              </Button>
              <Button 
                variant="ghost" 
                size="icon"
                className="h-8 w-8 hover:text-primary active:text-secondary transition-colors duration-200 text-gray-900"
                onClick={() => handleNavigation("/blog")}
              >
                <BookOpenText className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </div>
        <Separator className="my-6 md:my-8 opacity-30" />
        <div className="text-center text-sm text-gray-900">
          © {new Date().getFullYear()} PorteroYa. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
